import { render, staticRenderFns } from "./veJkyProjectWorkPro.vue?vue&type=template&id=19631842&scoped=true"
import script from "./veJkyProjectWorkPro.vue?vue&type=script&lang=js"
export * from "./veJkyProjectWorkPro.vue?vue&type=script&lang=js"
import style0 from "./veJkyProjectWorkPro.vue?vue&type=style&index=0&id=19631842&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19631842",
  null
  
)

export default component.exports